import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Проверка на то, что URL картинки возвращает успешный ответ
 * @param {string} imageUrl - URL картинки
 * @return {Promise<boolean>} - Возвращается ли успех
 */
export function getIsImageAccessible(_x) {
  return _getIsImageAccessible.apply(this, arguments);
}
/**
 * Меняет испорченные картинки на фолбэк
 */
function _getIsImageAccessible() {
  _getIsImageAccessible = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(imageUrl) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", new Promise(function (resolve) {
            // Create a new image element
            var img = new Image();

            // Set up event handlers
            img.onload = function () {
              return resolve(true);
            };
            img.onerror = function () {
              return resolve(false);
            };

            // Initiate the image loading
            img.src = imageUrl;
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getIsImageAccessible.apply(this, arguments);
}
export function getFallbacksForImages(_x2, _x3) {
  return _getFallbacksForImages.apply(this, arguments);
}
function _getFallbacksForImages() {
  _getFallbacksForImages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(imageUrls, fallbackUrl) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", Promise.all(imageUrls.map( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
              var isAccessible;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.prev = 0;
                    _context2.next = 3;
                    return getIsImageAccessible(url);
                  case 3:
                    isAccessible = _context2.sent;
                    return _context2.abrupt("return", isAccessible ? url : fallbackUrl);
                  case 7:
                    _context2.prev = 7;
                    _context2.t0 = _context2["catch"](0);
                    return _context2.abrupt("return", fallbackUrl);
                  case 10:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2, null, [[0, 7]]);
            }));
            return function (_x4) {
              return _ref.apply(this, arguments);
            };
          }())));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _getFallbacksForImages.apply(this, arguments);
}